import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { IBlocktimeReportTotalValueViewModel } from '../../block-time-report.model';

@Component({
  selector: 'app-block-time-report-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './block-time-report-grid.component.html',
  styleUrls: ['./block-time-report-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DecimalPipe],
})
export class BlockTimeReportGridComponent {
  private readonly decimalPipe = inject(DecimalPipe);

  @Input() data: IBlocktimeReportTotalValueViewModel[] = [];

  formatValue(item: IBlocktimeReportTotalValueViewModel, prop: 'sum' | 'subTotal') {
    const value = this.decimalPipe.transform(item[prop], '1.2-2');
    switch (item.prop) {
      case 'sumFlightMargin':
      case 'sumRate':
        return `${value} %`;
      case 'sumOBRepoHours':
      case 'sumIBRepoHours':
      case 'sumLiveFlightHours':
      case 'sumActualBlockTime':
      case 'sumCancellationHours':
      case 'sumBilledHours':
      case 'sumEstimatedBlockHours':
        return value;
      case 'sumCost':
      case 'sumProfit':
        return `$ ${value}`;
      default:
        return item[prop];
    }
  }
}
